// extracted by mini-css-extract-plugin
export var border = "_1w-8";
export var brand = "_1w-t";
export var button = "_1w-l";
export var center = "_1w-a";
export var centered = "_1w-6";
export var closeButton = "_1w-c";
export var disabledWrapper = "_1w-m";
export var error = "_1w-p";
export var extraLarge = "_1w-4";
export var extraSmall = "_1w-1";
export var fill = "_1w-i";
export var footer = "_1w-h";
export var footerAction = "_1w-j";
export var footerButtons = "_1w-k";
export var header = "_1w-7";
export var headerWithClose = "_1w-d";
export var icon = "_1w-o";
export var info = "_1w-s";
export var inline = "_1w-9";
export var large = "_1w-3";
export var main = "_1w-e";
export var modal = "_1w-0";
export var nearFull = "_1w-5";
export var neutral = "_1w-u";
export var noPadding = "_1w-g";
export var none = "_1w-v";
export var scrollable = "_1w-f";
export var small = "_1w-2";
export var success = "_1w-r";
export var tight = "_1w-n";
export var titleIcon = "_1w-b";
export var warn = "_1w-q";